<template>
  <div id="login">
    <section class="pb-2">
      <SiteNav></SiteNav>
      <div
        class="col-12 text-center py-3"
        data-aos="fade-down"
        data-aos-delay="100"
      >
        <div class="row"></div>
      </div>

      <div
        class="separador text-center mt-5 py-5"
        data-aos="fade-up"
        data-aos-delay="600"
      >
        <p class="fXG amarillo">Edición de datos</p>
      </div>

      <div class="container-fluid">
        <!-- <div class="row pb-5">
        <div class="col-12 blockd fG amarillo">Semana 1</div>
      </div>-->

        <div class="row">
          <div
            class="col-md-12 pt-5 mt-5"
            data-aos="fade-left"
            data-aos-delay="500"
          >
            <div class="row">
              <div class="col-12">
                <p class="">
                  <strong>Clínica 10 am: </strong> {{ cuenta_10am }} disponibles
                </p>
                <p class="">
                  <strong>Clínica 11 am: </strong> {{ cuenta_11am }} disponibles
                </p>
                <p class="">
                  <strong>Clínica 12 pm: </strong> {{ cuenta_12pm }} disponibles
                </p>
                <p class="">
                  <strong>Clínica 1 pm: </strong> {{ cuenta_1pm }} disponibles
                </p>
                <p class="">
                  <strong>Torneo: </strong> {{ cuenta_torneo }} disponibles
                </p>
              </div>
            </div>

            <form
              @submit="signup($event)"
              class="py-5 r15 mt-5"
              v-if="datos_user != null"
            >
              <div class="col-12 text-left pb-4 fXG">
                <span class="">REGISTRO</span>
              </div>
              <div class="col-12">
                <div class="row pb-4">
                  <!-- <div class="col-lg-12 pb-0">
                    <div class="negro fG">Nombre</div>
                    <input
                      v-model.trim="signupForm.codigo"
                      type="text"
                      placeholder="Clave de registro*"
                      required
                      
                    />
                  </div> -->
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Nombre</div> -->
                    <input
                      v-model.trim="signupForm.nombre_1"
                      type="text"
                      placeholder="Nombre*"
                      @input="
                        signupForm.nombre_1 = $event.target.value.toUpperCase()
                      "
                      required
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Nombre</div> -->
                    <input
                      v-model.trim="signupForm.nombre_2"
                      type="text"
                      placeholder="Segundo Nombre"
                      @input="
                        signupForm.nombre_2 = $event.target.value.toUpperCase()
                      "
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Apellido</div> -->
                    <input
                      v-model.trim="signupForm.apellido_paterno"
                      type="text"
                      placeholder="Apellido Paterno"
                      @input="
                        signupForm.apellido_paterno =
                          $event.target.value.toUpperCase()
                      "
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Apellido</div> -->
                    <input
                      v-model.trim="signupForm.apellido_materno"
                      type="text"
                      placeholder="Apellido Materno"
                      @input="
                        signupForm.apellido_materno =
                          $event.target.value.toUpperCase()
                      "
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Apellido</div> -->
                    <input
                      v-model.trim="signupForm.empresa"
                      type="text"
                      placeholder="Empresa*"
                      @input="
                        signupForm.empresa = $event.target.value.toUpperCase()
                      "
                      required
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Apellido</div> -->
                    <input
                      v-model.trim="signupForm.puesto"
                      type="text"
                      placeholder="Puesto"
                      @input="
                        signupForm.puesto = $event.target.value.toUpperCase()
                      "
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Apellido</div> -->
                    <input
                      v-model.trim="signupForm.email_user"
                      type="email"
                      placeholder="Correo Electrónico*"
                      @input="
                        signupForm.email_user =
                          $event.target.value.toLowerCase()
                      "
                      required
                    />
                  </div>

                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Apellido</div> -->
                    <select v-model="signupForm.genero" required>
                      <option value="">Género*</option>

                      <option value="Masculino">Masculino</option>
                      <option value="Femenino">Femenino</option>
                    </select>
                  </div>

                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-lg-5 pb-0">
                        <!-- <div class="negro fG">Correo Electrónico</div> -->
                        <select v-model="signupForm.codigo_pais" required>
                          <option value="">Código País</option>

                          <option value="+52">MÉXICO +52</option>
                          <option value="+1">ESTADOS UNIDOS +1</option>
                          <option value="+1">CANADÁ +1</option>
                          <option value="+55">BRASIL +55</option>

                          <!-- <optgroup label="_____________">
                            <option value="+7">+7</option>
                            <option value="+20">+20</option>
                            <option value="+27">+27</option>
                            <option value="+30">+30</option>
                            <option value="+31">+31</option>
                            <option value="+32">+32</option>
                            <option value="+33">+33</option>
                            <option value="+34">+34</option>
                            <option value="+36">+36</option>
                            <option value="+39">+39</option>
                            <option value="+40">+40</option>
                            <option value="+41">+41</option>
                            <option value="+43">+43</option>
                            <option value="+44">+44</option>
                            <option value="+45">+45</option>
                            <option value="+46">+46</option>
                            <option value="+47">+47</option>
                            <option value="+48">+48</option>
                            <option value="+49">+49</option>
                            <option value="+51">+51</option>
                            <option value="+53">+53</option>
                            <option value="+54">+54</option>
                            <option value="+56">+56</option>
                            <option value="+57">+57</option>
                            <option value="+58">+58</option>
                            <option value="+60">+60</option>
                            <option value="+61">+61</option>
                            <option value="+62">+62</option>
                            <option value="+63">+63</option>
                            <option value="+64">+64</option>
                            <option value="+65">+65</option>
                            <option value="+66">+66</option>
                            <option value="+81">+81</option>
                            <option value="+82">+82</option>
                            <option value="+84">+84</option>
                            <option value="+86">+86</option>
                            <option value="+90">+90</option>
                            <option value="+91">+91</option>
                            <option value="+92">+92</option>
                            <option value="+93">+93</option>
                            <option value="+94">+94</option>
                            <option value="+95">+95</option>
                            <option value="+98">+98</option>
                            <option value="+211">+211</option>
                            <option value="+212">+212</option>
                            <option value="+213">+213</option>
                            <option value="+216">+216</option>
                            <option value="+218">+218</option>
                            <option value="+220">+220</option>
                            <option value="+221">+221</option>
                            <option value="+222">+222</option>
                            <option value="+223">+223</option>
                            <option value="+224">+224</option>
                            <option value="+225">+225</option>
                            <option value="+226">+226</option>
                            <option value="+227">+227</option>
                            <option value="+228">+228</option>
                            <option value="+229">+229</option>
                            <option value="+230">+230</option>
                            <option value="+231">+231</option>
                            <option value="+232">+232</option>
                            <option value="+233">+233</option>
                            <option value="+234">+234</option>
                            <option value="+235">+235</option>
                            <option value="+236">+236</option>
                            <option value="+237">+237</option>
                            <option value="+238">+238</option>
                            <option value="+239">+239</option>
                            <option value="+240">+240</option>
                            <option value="+241">+241</option>
                            <option value="+242">+242</option>
                            <option value="+243">+243</option>
                            <option value="+244">+244</option>
                            <option value="+245">+245</option>
                            <option value="+246">+246</option>
                            <option value="+248">+248</option>
                            <option value="+249">+249</option>
                            <option value="+250">+250</option>
                            <option value="+251">+251</option>
                            <option value="+252">+252</option>
                            <option value="+253">+253</option>
                            <option value="+254">+254</option>
                            <option value="+255">+255</option>
                            <option value="+256">+256</option>
                            <option value="+257">+257</option>
                            <option value="+258">+258</option>
                            <option value="+260">+260</option>
                            <option value="+261">+261</option>
                            <option value="+262">+262</option>
                            <option value="+263">+263</option>
                            <option value="+264">+264</option>
                            <option value="+265">+265</option>
                            <option value="+266">+266</option>
                            <option value="+267">+267</option>
                            <option value="+268">+268</option>
                            <option value="+269">+269</option>
                            <option value="+290">+290</option>
                            <option value="+291">+291</option>
                            <option value="+297">+297</option>
                            <option value="+298">+298</option>
                            <option value="+299">+299</option>
                            <option value="+350">+350</option>
                            <option value="+351">+351</option>
                            <option value="+352">+352</option>
                            <option value="+353">+353</option>
                            <option value="+354">+354</option>
                            <option value="+355">+355</option>
                            <option value="+356">+356</option>
                            <option value="+357">+357</option>
                            <option value="+358">+358</option>
                            <option value="+359">+359</option>
                            <option value="+370">+370</option>
                            <option value="+371">+371</option>
                            <option value="+372">+372</option>
                            <option value="+373">+373</option>
                            <option value="+374">+374</option>
                            <option value="+375">+375</option>
                            <option value="+376">+376</option>
                            <option value="+377">+377</option>
                            <option value="+378">+378</option>
                            <option value="+380">+380</option>
                            <option value="+381">+381</option>
                            <option value="+382">+382</option>
                            <option value="+385">+385</option>
                            <option value="+386">+386</option>
                            <option value="+387">+387</option>
                            <option value="+389">+389</option>
                            <option value="+420">+420</option>
                            <option value="+421">+421</option>
                            <option value="+423">+423</option>
                            <option value="+500">+500</option>
                            <option value="+501">+501</option>
                            <option value="+502">+502</option>
                            <option value="+503">+503</option>
                            <option value="+504">+504</option>
                            <option value="+505">+505</option>
                            <option value="+506">+506</option>
                            <option value="+507">+507</option>
                            <option value="+508">+508</option>
                            <option value="+509">+509</option>
                            <option value="+590">+590</option>
                            <option value="+591">+591</option>
                            <option value="+592">+592</option>
                            <option value="+593">+593</option>
                            <option value="+594">+594</option>
                            <option value="+595">+595</option>
                            <option value="+596">+596</option>
                            <option value="+597">+597</option>
                            <option value="+598">+598</option>
                            <option value="+670">+670</option>
                            <option value="+672">+672</option>
                            <option value="+673">+673</option>
                            <option value="+674">+674</option>
                            <option value="+675">+675</option>
                            <option value="+676">+676</option>
                            <option value="+677">+677</option>
                            <option value="+678">+678</option>
                            <option value="+679">+679</option>
                            <option value="+680">+680</option>
                            <option value="+681">+681</option>
                            <option value="+682">+682</option>
                            <option value="+683">+683</option>
                            <option value="+685">+685</option>
                            <option value="+686">+686</option>
                            <option value="+687">+687</option>
                            <option value="+688">+688</option>
                            <option value="+689">+689</option>
                            <option value="+690">+690</option>
                            <option value="+691">+691</option>
                            <option value="+692">+692</option>
                            <option value="+850">+850</option>
                            <option value="+852">+852</option>
                            <option value="+853">+853</option>
                            <option value="+855">+855</option>
                            <option value="+856">+856</option>
                            <option value="+870">+870</option>
                            <option value="+880">+880</option>
                            <option value="+886">+886</option>
                            <option value="+960">+960</option>
                            <option value="+961">+961</option>
                            <option value="+962">+962</option>
                            <option value="+963">+963</option>
                            <option value="+964">+964</option>
                            <option value="+965">+965</option>
                            <option value="+966">+966</option>
                            <option value="+967">+967</option>
                            <option value="+968">+968</option>
                            <option value="+970">+970</option>
                            <option value="+971">+971</option>
                            <option value="+972">+972</option>
                            <option value="+973">+973</option>
                            <option value="+974">+974</option>
                            <option value="+975">+975</option>
                            <option value="+976">+976</option>
                            <option value="+977">+977</option>
                            <option value="+992">+992</option>
                            <option value="+993">+993</option>
                            <option value="+994">+994</option>
                            <option value="+995">+995</option>
                            <option value="+996">+996</option>
                            <option value="+998">+998</option>
                            <option value="+5999">+5999</option>
                            <option value="+1 242">+1 242</option>
                            <option value="+1 246">+1 246</option>
                            <option value="+1 264">+1 264</option>
                            <option value="+1 268">+1 268</option>
                            <option value="+1 284">+1 284</option>
                            <option value="+1 340">+1 340</option>
                            <option value="+1 345">+1 345</option>
                            <option value="+1 441">+1 441</option>
                            <option value="+1 473">+1 473</option>
                            <option value="+1 599">+1 599</option>
                            <option value="+1 649">+1 649</option>
                            <option value="+1 664">+1 664</option>
                            <option value="+1 670">+1 670</option>
                            <option value="+1 671">+1 671</option>
                            <option value="+1 684">+1 684</option>
                            <option value="+1 721">+1 721</option>
                            <option value="+1 758">+1 758</option>
                            <option value="+1 767">+1 767</option>
                            <option value="+1 784">+1 784</option>
                            <option value="+1 809">+1 809</option>
                            <option value="+1 868">+1 868</option>
                            <option value="+1 869">+1 869</option>
                            <option value="+1 876">+1 876</option>
                          </optgroup> -->
                        </select>
                      </div>

                      <div class="col-lg-7 pb-0">
                        <!-- <div class="negro fG">Correo Electrónico</div> -->
                        <input
                          v-model.trim="signupForm.telefono"
                          type="tel"
                          placeholder="Teléfono"
                          maxlength="10"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Apellido</div> -->
                    <input
                      v-model.trim="signupForm.movil"
                      type="tel"
                      placeholder="Móvil*"
                      maxlength="10"
                      required
                    />
                  </div>

                  <div
                    class="col-lg-12 py-3"
                    v-if="signupForm.tipo != 'PATROCINADOR'"
                  >
                    <!-- <div class="negro fG">Apellido</div> -->
                    <span class="negro pl-2">
                      <b>¿Asistirás a la comida? *</b>
                    </span>
                    <br />
                    <label class="pointer">
                      <select
                        v-model="signupForm.comida"
                        @change="changeComida($event)"
                      >
                        <option value=""></option>
                        <option value="SI">SI</option>
                        <option value="NO">NO</option>
                      </select>
                    </label>
                  </div>
                  <div
                    class="col-lg-12 py-3"
                    v-else-if="
                      signupForm.tipo == 'PATROCINADOR' &&
                      signupForm.comida == 'SI'
                    "
                  >
                    <span class="negro pl-2"> ¿Asistirás a la comida?</span>
                    <br />
                    <label class="pointer">
                      <select
                        v-model="signupForm.comida"
                        @change="changeComida($event)"
                      >
                        <option value=""></option>
                        <option value="SI">SI</option>
                        <option value="NO">NO</option>
                      </select>
                    </label>
                  </div>

                  <div
                    class="col-lg-12 py-3"
                    v-if="signupForm.tipo != 'PATROCINADOR'"
                  >
                    <span class="mt-4"
                      >Selecciona la actividad en la que participarás, recuerda
                      que solo puedes elegir una:</span
                    >
                  </div>
                  <div
                    class="col-lg-12 py-3"
                    v-else-if="torneo_db == 'SI' || clinica_db == 'SI'"
                  >
                    <span class="mt-4"
                      >Selecciona la actividad en la que participarás:</span
                    >
                  </div>

                  <div
                    class="col-lg-12 py-3"
                    v-if="signupForm.tipo != 'PATROCINADOR'"
                  >
                    <label class="pointer">
                      <select
                        v-model="signupForm.evento"
                        @change="changeEvento($event)"
                        required
                      >
                        <option value="">Actividad *</option>
                        <option value="Ninguno">Ninguno</option>
                        <option value="Torneo">Torneo</option>
                        <option value="Clínica">Clínica de Golf</option>
                      </select>
                    </label>
                  </div>
                  <div
                    class="col-lg-12 py-3"
                    v-else-if="torneo_db == 'SI' || clinica_db == 'SI'"
                  >
                    <label class="pointer">
                      <select
                        v-model="signupForm.evento"
                        @change="changeEvento($event)"
                        required
                      >
                        <option value="">Actividad</option>
                        <option value="Ninguno">Ninguno</option>
                        <option value="Torneo" v-if="torneo_db == 'SI'">
                          Torneo
                        </option>
                        <option value="Clínica" v-if="clinica_db == 'SI'">
                          Clínica de Golf
                        </option>
                      </select>
                    </label>
                  </div>

                  <!-- <div class="col-lg-12 pb-0" v-if="signupForm.torneo == 'SI'">
                    <select v-model="signupForm.talla_tops" required>
                      <option value="">Talla de prenda superior</option>
                      <option value="XS">XS</option>
                      <option value="S">S</option>
                      <option value="M">M</option>
                      <option value="L">L</option>
                      <option value="XL">XL</option>
                    </select>
                  </div> -->

                  <div class="col-lg-12 pb-0" v-if="signupForm.torneo == 'SI'">
                    <input
                      v-model.trim="signupForm.handicap"
                      type="text"
                      placeholder="Handicap*"
                      required
                    />
                  </div>

                  <div
                    class="col-lg-12 pb-3"
                    v-if="
                      signupForm.torneo == 'SI' &&
                      signupForm.genero == 'Masculino'
                    "
                  >
                    <select v-model="signupForm.talla_tops" required>
                      <option value="">TALLA DE CHAMARRA*</option>
                      <option value="CH">CH</option>
                      <option value="M">M</option>
                      <option value="G">G</option>
                      <option value="EXG">EXG</option>
                      <option value="EXXG">EXXG</option>
                    </select>
                    <!-- <span>
                      *
                      <span @click="toggleOverlay()" class="dorado pointer"
                        >Ver la guía</span
                      >
                      de tallas. Son tallas US y en calzado de golf no
                      existen medios números.
                    </span> -->
                  </div>
                  <div class="col-lg-12 pb-0" v-if="signupForm.clinica == 'SI'">
                    <select v-model="signupForm.talla_guantes" required>
                      <option value="">Talla de guante*</option>
                      <option value="S">S</option>
                      <option value="M">M</option>
                      <option value="L">L</option>
                      <option value="XL">XL</option>
                    </select>
                  </div>
                  <div
                    class="col-lg-12 pb-0"
                    v-if="
                      signupForm.torneo == 'SI' &&
                      signupForm.genero == 'Femenino'
                    "
                  >
                    <select v-model="signupForm.talla_tops" required>
                      <option value="">TALLA DE CHAMARRA*</option>
                      <option value="CH">CH</option>
                      <option value="M">M</option>
                      <option value="G">G</option>
                      <option value="EXG">EXG</option>
                      <option value="EXXG">EXXG</option>
                    </select>
                    <!-- <span>
                      *
                      <span @click="toggleOverlay()" class="dorado pointer"
                        >Ver la guía</span
                      >
                      de tallas. Son tallas US y en calzado de golf no existen
                      medios números.
                    </span> -->
                  </div>

                  <div class="col-lg-12 pb-0" v-if="signupForm.clinica == 'SI'">
                    <select v-model="signupForm.horario_clinica" required>
                      <option value="">Selecciona un horario*</option>
                      <option value="10 am">10 am</option>
                      <option value="11 am">11 am</option>
                      <option value="12 pm">12 pm</option>
                      <option value="1 pm">1 pm</option>
                    </select>
                  </div>
                </div>

                <!-- <div class="row pb-5">
                  <label
                    class="col-12 pointer d-flex justify-content-start align-items-center"
                  >
                    <input
                      type="checkbox"
                      v-model="signupForm.terminos"
                      required
                    />
                    <div class="pl-3 negro">
                      He leído y acepto el
                      <a
                        href="/aviso-de-privacidad"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        aviso de privacidad</a
                      >
                      *
                    </div>
                  </label>
                </div> -->

                <div class="row pb-5">
                  <div class="col-12 text-center">
                    <button
                      type="submit"
                      class="pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto"
                    >
                      ACTUALIZAR DATOS
                    </button>
                  </div>
                </div>
              </div>
              <!-- <div class="extras text-center">
                    <a @click="toggleForm()" class="pointer"
                      >Regresar al Login</a
                    >
                  </div> -->
            </form>
          </div>
        </div>

        <div class="row">
          <div class="col-12 py-5"></div>
        </div>
        <div class="row">
          <div class="col-12 py-5"></div>
        </div>
        <div class="row">
          <div class="col-12 py-5"></div>
        </div>
        <div class="row">
          <div class="col-12 py-5"></div>
        </div>
        <div class="row">
          <div class="col-12 py-5"></div>
        </div>
      </div>

      <Footer></Footer>
      <!-- <Glyphicons></Glyphicons> -->
    </section>
  </div>
</template>


<script>
const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 42;
import Footer from "@/components/Footer";
// import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import SiteNav from "@/components/SiteNav2";

import * as fb from "../firebase";
import * as moment from "moment";
import { ticketsCollection, usersCollection } from "@/firebase";
import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    Footer,
    SiteNav,
    // Glyphicons,
  },
  data() {
    return {
      codigo_disponible: "",
      cuenta_10am: "",
      cuenta_11am: "",
      cuenta_12pm: "",
      cuenta_1pm: "",
      cuenta_torneo: "",
      reenvioForm: {
        codigo: "",
      },

      preForm: {
        codigo: "",
        apellido_paterno: "",
        email: "",
      },
      signupForm: {
        id: "",
        codigo: "",
        nombre_1: "",
        nombre_2: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        codigo_pais: "",
        telefono: "",
        movil: "",
        comida: "NO",
        torneo: "NO",
        handicap: "",
        talla_tops: "",
        clinica: "NO",
        talla_guantes: "",
        horario_clinica: "",
        talla_cubrebocas: "",
        terminos: false,
        evento: "",
        genero: "",
        tipo: "",
      },

      columnsRegistros: [
        "codigo",
        "nombre_1",
        "nombre_2",
        "apellido_paterno",
        "apellido_materno",
        "empresa",
        "puesto",
        "email",
        "codigo_pais",
        "telefono",
        "movil",
        "comida",
        "torneo",
        "handicap",
        "talla_tops",
        "clinica",
        "talla_guantes",
        "talla_cubrebocas",
        "terminos",
      ],
      columnsInvitados: [
        "codigo",
        "nombre_1",
        "nombre_2",
        "apellido_paterno",
        "apellido_materno",
        "empresa",
        "puesto",
        "email",
        "codigo_pais",
        "telefono",
        "movil",
      ],
      columnsSolicitudes: [
        "no_cliente",
        "nombre",
        "apellido",
        "email",
        "estado",
        "FechaRegistro",
      ],
      data: null,
      options: {
        perPage: 100,
        editableColumns: [],
        sortable: [],
      },

      data_users: null,
      options_users: {
        perPage: 100,
        headings: {
          user_id: "UID",
          nombre: "Nombre",
          apellido: "Apellido",
          email: "Email",
          tel: "Tel",
          fecha_nacimiento: "Fec. Nac.",
          edad: "Edad",
          suma_puntos: "Suma Puntos",
          suma_time: "Suma Segundos",
          suma_time_txt: "Tiempo Total",
          num_tickets: "Número de Tickets",
          created_on: "Fecha de Registro",
          dia_registro: "Día de Registro",
        },
        editableColumns: [],
        sortable: [],
      },
      tickets: [],
      tickets_procesados: [],
      users: {},
      users_array: [],
      users_auth: [],
      centros: [],
      registros: [],
      invitados: [],
      user: null,
      datos_user: null,
      id_user: null,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.id_user = this.$route.params.id;

    this.user = JSON.parse(localStorage.getItem("user_copaprosa2021"));

    this.getRegistro();
    this.getCodigoYDiponibilidad();
  },
  methods: {
    async changeStatusComida(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusComida.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusTorneo(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusTorneo.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusClinica(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusClinica.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusTalla(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusTalla.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusGuantes(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusGuantes.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusCubrebocas(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusCubrebocas.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    getInvitados() {
      console.log("get invitados");

      const https = require("https");
      var qData = {
        // id: this.user.no_cliente,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getInvitados.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.invitados = res.datos;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    getRegistros() {
      console.log("get registros");

      const https = require("https");
      var qData = {
        no_cliente: this.user.no_cliente,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getRegistros.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.registros = res.datos;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    presignup(e) {
      e.preventDefault();

      console.log({ presignup: this.preForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.preForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "presignup.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio presingup");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //swal.fire("Bien", res.msg, "success");

              console.log(res.datos);
              console.log(res.datos[0].codigo);
              console.log(res.datos[0].email);

              this.signupForm.codigo = res.datos[0].codigo;
              //this.signupForm.email_user = res.datos[0].email;
              this.signupForm.nombre_1 = res.datos[0].nombre_1;
              this.signupForm.nombre_2 = res.datos[0].nombre_2;
              this.signupForm.apellido_paterno = res.datos[0].apellido_paterno;
              this.signupForm.apellido_materno = res.datos[0].apellido_materno;
              this.signupForm.empresa = res.datos[0].empresa;
              this.signupForm.puesto = res.datos[0].puesto;
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;

              this.reenvioForm.codigo = "";

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else if (res.status === "reenvio") {
              this.reenvioForm.codigo = res.codigo_reenvio;
              this.mensaje_reenvio = res.msg;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    reenvio() {
      console.log({ reenvio: this.reenvioForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.reenvioForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio reenvio");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e) {
      e.preventDefault();

      console.log({ registro: this.signupForm });
      this.enviaRegistro();
    },
    async enviaRegistro() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "edicion.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success").then(() => {
                thes.$router.push('/administrador/dashboard/');
              });
              this.getCodigoYDiponibilidad();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    changeEvento(e) {
      if (this.signupForm.evento == "Clínica") {
        this.signupForm.clinica = "SI";
        this.signupForm.torneo = "NO";
      } else if (this.signupForm.evento == "Torneo") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "SI";
      } else if (this.signupForm.evento == "Ninguno") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "NO";
      }
      this.signupForm.talla_guantes = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeComida(e) {
      // if (this.signupForm.comida == "NO") {
      //   this.signupForm.torneo = "NO";
      //   this.signupForm.clinica = "NO";
      // }
      // this.signupForm.talla_guantes = "";
      // this.signupForm.handicap = "";
      // this.signupForm.talla_tops = "";
    },
    changeTorneo(e) {
      if (this.signupForm.torneo === "SI") {
        this.signupForm.clinica = "NO";
        this.signupForm.talla_guantes = "";
      } else {
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      }
    },
    changeClinica(e) {
      if (this.signupForm.clinica === "SI") {
        this.signupForm.torneo = "NO";
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      } else {
        this.signupForm.talla_guantes = "";
      }
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    resetForm() {
      this.signupForm = {
        codigo: "",
        nombre_1: "",
        nombre_2: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        codigo_pais: "",
        telefono: "",
        movil: "",
        torneo: false,
        handicap: "",
        talla_tops: "",
        clinica: false,
        talla_zapatos: "",
        talla_guantes: "",
        horario_clinica: "",
        talla_cubrebocas: "",
        terminos: false,
        evento: "",
      };
      this.centroForm = {
        clasificacion: "",
        no_cliente: "",
        nombre_completo: "",
        cedis: "",
        objetivo_semanal: "",
      };
    },
    getCodigoYDiponibilidad() {
      console.log("get codigo y disponibilidad");

      const https = require("https");
      var qData = {};
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getCodigoYDisponibilidad.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.codigo_disponible = res.codigo_disponible;
              this.signupForm.codigo = res.codigo_disponible;
              this.cuenta_10am = res.cuenta_10am;
              this.cuenta_11am = res.cuenta_11am;
              this.cuenta_12pm = res.cuenta_12pm;
              this.cuenta_1pm = res.cuenta_1pm;
              this.cuenta_torneo = res.cuenta_torneo;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    getRegistro() {
      console.log("get codigo y disponibilidad");

      const https = require("https");
      var qData = {
        id: this.id_user,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getRegistroEdicion.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res get registro");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.datos_user = res.datos;
              console.log({ datos_user: this.datos_user });

              this.signupForm.id = res.datos[0].id;
              this.signupForm.nombre_1 = res.datos[0].nombre_1;
              this.signupForm.nombre_2 = res.datos[0].nombre_2;
              this.signupForm.apellido_paterno = res.datos[0].apellido_paterno;
              this.signupForm.apellido_materno = res.datos[0].apellido_materno;
              this.signupForm.empresa = res.datos[0].empresa;
              this.signupForm.puesto = res.datos[0].puesto;
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;

              this.signupForm.email_user = res.datos[0].email;
              this.signupForm.codigo_pais = res.datos[0].codigo_pais;

              this.signupForm.tipo = res.datos[0].tipo;

              this.signupForm.comida = res.datos[0].comida;
              this.signupForm.torneo = res.datos[0].torneo;
              this.signupForm.clinica = res.datos[0].clinica;

              this.signupForm.talla_zapatos = res.datos[0].talla_zapatos;

              this.signupForm.talla_guantes = res.datos[0].talla_guantes;
              this.signupForm.horario_clinica = res.datos[0].horario_clinica;

              this.signupForm.talla_tops = res.datos[0].talla_tops;

              if (this.signupForm.torneo == "SI") {
                this.signupForm.evento = "Torneo";
              } else if (this.signupForm.clinica == "SI") {
                this.signupForm.evento = "Clínica";
              }

              this.signupForm.handicap = res.datos[0].handicap;
              this.signupForm.genero = res.datos[0].genero;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
  },
};
</script>

